export default __webpack_public_path__ + "static/africaHeader-fe26411b101ca534dd92c15146198eb7.jpg";